<div class="activity-details">
    <c-auto-form config="setModelObjectsCtrl.autoFormConfig"></c-auto-form>
</div>
